import React from "react";
import {
  MDBEdgeHeader,
  MDBFreeBird,
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBCardBody,
  MDBIcon,
  MDBCard,
  MDBCardTitle,
  MDBCardImage,
  MDBCardText,
  MDBAnimation,
  MDBNavLink,
  MDBBtn,
  MDBProgress,
  MDBTypography,
  MDBView,
  MDBSpinner,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
} from "mdbreact";
import { Pie, Bar, Line } from "react-chartjs-2";
import "./HomePage.css";
import TopNavbar from "../../components/topNavbar";
import padLogo from '../../assets/pad.png';
import pajakLogo from '../../assets/pajak.png';
import bphtbLogo from '../../assets/bphtb.png';
import monitoringLogo from '../../assets/monitoring.png';
import paymentLogo from '../../assets/payment.png';

class HomePage extends React.Component {

  render() {


    return (
      <>
        <TopNavbar />
        <div className="mb-20" />
        <MDBEdgeHeader color="indigo darken-3" className="sectionPage" />
        <div style={{ marginTop: "-200px" }}>
          <MDBContainer fluid>
            <MDBRow>
                  <MDBCol sm={12}>
                      <MDBCard>
                          <MDBCardBody>

                                  <MDBRow className='p-3'>
                                  
                                       <MDBCol md={4} className="mb-4">
                                        <div className="flex flex-col p-5 text-center justify-center items-center border rounded">
                                            <img src={pajakLogo} width={60} alt=""/>
                                                   <span className='text-xl'>PAJAK</span>
                                                    <span className="text-sm">Aplikasi Pengelolaan Pajak Daerah</span>
                                                    <a  href='https://pajak.kotamobagukota.go.id/'  class='hover:bg-blue-500 hover:text-white btn btn-outline-primary btn-sm mt-4'>Masuk Aplikasi</a>

                                                </div>
                                        </MDBCol>
                                        <MDBCol md={4} className="mb-4">
                                        <div className="flex flex-col p-5 text-center justify-center items-center border rounded">
                                                <img src={bphtbLogo} width={60} alt=""/>
                                                    <span className='text-xl'>BPHTB</span>
                                                    <span className="text-sm">Aplikasi Pengelolaan Pajak BPHTB</span>
                                                    <a  href='https://bphtb.kotamobagukota.go.id/'  class='hover:bg-blue-500 hover:text-white btn btn-outline-primary btn-sm mt-4'>Masuk Aplikasi</a>

                                                </div>
                                        </MDBCol>
                                        <MDBCol md={4} className="mb-4">
                                        <div className="flex flex-col p-5 text-center justify-center items-center border rounded">
                                                <img src={monitoringLogo} width={60} alt=""/>
                                                    <span className='text-xl'>E-MONITORING</span>
                                                    <span className="text-sm">Aplikasi Monitoring Mesin Pajak yang tersebar</span>
                                                    <a  href='https://pad.kotamobagu.go.id/emonitoring'  class='hover:bg-blue-500 hover:text-white btn btn-outline-primary btn-sm mt-4'>Masuk Aplikasi</a>

                                                </div>
                                        </MDBCol>
                                        <MDBCol md={4} className="mb-4">
                                        <div className="flex flex-col p-5 text-center justify-center items-center border rounded">
                                                <img src={paymentLogo} width={60} alt=""/>
                                                    <span className='text-xl'>E-PAYMENT</span>
                                                    <span className="text-sm">Monitoring Pembayaran berbagai channel pembayran yang terintegrasi </span>
                                                    <a  href='https://bpkd.kotamobagu.go.id/payment'  class='hover:bg-blue-500 hover:text-white btn btn-outline-primary btn-sm mt-4'>Masuk Aplikasi</a>

                                                </div>
                                        </MDBCol>
                                        <MDBCol md={4} className="mb-4">
                                        <div className="flex flex-col p-5 text-center justify-center items-center border rounded">
                                                <img src={padLogo} width={60} alt=""/>
                                                    <span className='text-xl'>E-RETRIBUSI</span>
                                                    <span className="text-sm">Pengelolaan Pendapatan Retribusi Daerah </span>
                                                    <span   onClick={()=>alert('dalam tahap pengembangan')} class='hover:bg-blue-500 hover:text-white btn btn-outline-primary btn-sm mt-4'>Masuk Aplikasi</span>

                                                </div>
                                        </MDBCol>


                                  </MDBRow>

                          </MDBCardBody>
                      </MDBCard>
                  </MDBCol>
            </MDBRow>
          </MDBContainer>
        </div>
      </>
    );
  }
}

export default HomePage;
